/**
 * Stylex:
 * Use Type to force the use of the breakpoints instead of the string
 * https://github.com/facebook/stylex/issues/112#issuecomment-1848066849
 *
 * Device resolutions:
 * Should use largest device resolution for each breakpoint
 * https://screensizes.app/?compare=iphone
 * https://mediag.com/blog/popular-screen-resolutions-designing-for-all/
 */

/**
 * Mobile
 * 根據站上GA數據，最大的手機寬度且最多人用的為 430px
 * 而 480 整除 8 是比較好的斷點設計
 */
export type MobileMediaQuery = '@media (max-width: 480px)'

/**
 * Tablet
 * 根據站上GA數據，最大的平板寬度且最多人用的為 1024px
 * 1280 以上就是桌機/筆電的斷點，且也剛好整除 8
 */
export type TabletMediaQuery = '@media (min-width: 481px) and (max-width: 1280px)'

/**
 * Desktop/Laptop
 * 根據站上數據前三名寬度為 1920, 1536, 1440
 */
export type DesktopMediaQuery = '@media (min-width: 1281px)'

/**
 * WordPress 客製化寬度
 * @deprecated 新的設計不會使用到這個斷點
 */
export type WordPressTabletMediaQuery = '@media (min-width: 961px)'
/**
 * WordPress 客製化寬度
 * @deprecated 新的設計不會使用到這個斷點
 */
export type WordPressMobileMediaQuery = '@media (max-width: 960px)'

/**
 * 對應 breakpoint 提供給元件的最大寬度，例如 Dialog 的 maxWidth, Container 的 maxWidth
 */
export const breakpointValues = {
  mobile: 480,
  tablet: 960,
  desktop: 1280,
}
